<template>
  <b-overlay :show="showOverlay" spinner-variant="primary">
    <ValidationObserver ref="searchForm" slim>
      <b-form @submit.prevent="submit" class="filters-form">
        <b-col md="12">
          <h5 class="search-title">Autocar</h5>
          <b-form-row>
            <b-col md="2">
              <ValidationProvider
                  name="Tip ruta"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                <b-form-group
                  label="Tip ruta"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="route"
                >
                  <b-form-select
                    id="route"
                    size="sm"
                    v-model="selectedParams.route_type"
                    :options="routeTypeOptions"
                    aria-describedby="route type"
                    ></b-form-select>
                    <b-form-invalid-feedback id="resort">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="2">
              <ValidationProvider
                  name="Tara destinatie"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                <b-form-group
                  label="Tara destinatie"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="to"
                >
                  <b-form-select
                    id="to"
                    size="sm"
                    v-model="destinationCountry"
                    :options="countryOptions"
                    aria-describedby="to"
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="resort">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="2">
              <ValidationProvider
                  name="Sosire la"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                <b-form-group
                  label="Sosire la"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="to"
                >
                  <b-form-select
                    id="city"
                    size="sm"
                    v-model="city"
                    :options="cityOptions"
                    :disabled="cityDisabled"
                    @change="onDestinationChange"
                    aria-describedby="city"
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="resort">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Zona"
                label-class="font-weight-bold my-0 py-0"
                label-for="area"
              >
                <b-form-select
                  id="area"
                  size="sm"
                  v-model="area"
                  :options="areaOptions"
                  :disabled="areaDisabled"
                  aria-describedby="area"
                  >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                    </template>
                  </b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <ValidationProvider
                  name="Plecare din"
                  :rules="{ required: true }"
                  v-slot="vContext"
                >
                <b-form-group
                  label="Plecare din"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="from"
                >
                  <b-form-select
                    id="from"
                    size="sm"
                    v-model="selectedParams.from"
                    :options="fromOptions"
                    :disabled="fromDisabled"
                    aria-describedby="from"
                    @change="onDepartureChange"
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="resort">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col md="2" v-if="selectedParams.route_type == 'return' || selectedParams.route_type == 'out'">
              <ValidationProvider
                name="Data plecare"
                :rules="{ required: true }"
                vid="checkIn"
                v-slot="vContext"
                >
                <b-form-group
                  label="Data plecare"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="checkIn">
                  <b-form-select
                    id="from"
                    size="sm"
                    v-model="selectedCheckIn"
                    :options="departureDatesOptions"
                    :disabled="departureDateDisabled"
                    @change="onCheckInChange"
                    aria-describedby="from"
                    >
                    <template v-slot:first>
                      <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="resort">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <b-col md="1" v-if="selectedParams.route_type == 'return'">
              <ValidationProvider
                  name="Nr zile"
                  :rules="{ required: true }"
                  vid="nights"
                  v-slot="vContext">
                  <b-form-group
                    label="Nr zile"
                    label-class="font-weight-bold my-0 py-0"
                    label-for="nights">
                    <b-input
                      v-model="nights"
                      size="sm"
                      disabled
                      aria-describedby="nights-live-feedback" />
                    <b-form-invalid-feedback id="nights-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col md="2" v-if="selectedParams.route_type == 'return' || selectedParams.route_type == 'in'">
              <ValidationProvider
                name="Data retur"
                label-class="font-weight-bold my-0 py-0"
                label-for="checkOut"
                :rules="{ required: true }"
                vid="checkOut"
                v-slot="vContext"
                >
                <b-form-group
                  label="Data retur"
                  label-class="font-weight-bold my-0 py-0"
                  label-for="checkOut"
                  >
                  <b-form-select
                    id="from"
                    size="sm"
                    v-model="selectedCheckOut"
                    :options="returnDatesOptions"
                    :disabled="returnDateDisabled"
                    @change="onCheckOutChange"
                    aria-describedby="from"
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- selecteaza --</b-form-select-option>
                      </template>
                  </b-form-select>
                  <b-form-invalid-feedback id="checkout-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                </b-form-group>
              </ValidationProvider>
             </b-col>
             <b-col md="3">
                <b-form-group
                label="Pasageri"
                label-class="font-weight-bold my-0 py-0"
                label-for="passengers">
                  <room
                    v-model="room"
                    :id="room"
                    :showDelete="false"
                    :showAdd = "false" />
                </b-form-group>
              </b-col>
            </b-form-row>
            <b-form-row>
                <b-col md="7">
                <p class="text-danger mt-3 text-center"><b>ATENTIE! Pentru rezervarile cu retur la mai mult de 8 zile se aplica supliment la facturare</b></p>
              </b-col>
              <b-col md="5" class="text-right pt-4">
                <b-button variant="outline-primary" size="sm" type="submit"><b-icon icon="search" /><span class="ml-2">Cauta</span></b-button>
              </b-col>
            </b-form-row>
        </b-col>
      </b-form>
    </ValidationObserver>
  </b-overlay>
</template>

<script>
import moment from 'moment'
import model from '../services/model'
import validation from 'b2b-common/mixins/validation'
import toast from 'b2b-common/mixins/toast'
import formMixin from '@/app/private/shared/mixins/search_forms'
import Room from '@/app/private/shared/components/search_form_room.vue'

import {
  getDeparturePoints,
  getDates
} from 'b2b-common/services/api/bus'

const countryLevel = 2

export default {
  components: { Room },
  mixins: [formMixin, validation, toast],
  props: ['params'],
  data () {
    return {
      selectedParams: {},
      defaultNights: 8,
      nights: 8,
      room: {},
      // destinations: model.destinations,
      // departureDates: [],
      // returnDates: [],
      country: null
    }
  },
  computed: {
    showOverlay () { return this.activeRequests.length > 0 },
    routeTypeOptions () {
      return [
        { value: 'return', text: 'Dus-Intors' },
        { value: 'out', text: 'Tur' },
        { value: 'in', text: 'Retur' }
      ]
    },
    fromOptions () {
      return model.departures.map(el => ({ value: el.id, text: el.name }))
    },
    fromDisabled () {
      return !this.city
    },
    cityOptions () {
      if (!this.destinationCountry) return []
      return model.destinations
        .filter(el => el.level === countryLevel + 1)
        .filter(el => el.parent_id === this.destinationCountry)
        .map(el => {
          let text = ''
          for (let i = 0; i < el.level; i++) text += '  '
          text += el.name
          return { value: el.id, text: text }
        })
    },
    city: {
      get () {
        const dest = model.destinations.find(el => (el.id === this.selectedParams.to))
        if (!dest) return null
        if (dest.level === countryLevel + 1) return dest.id
        const city = model.destinations.find(el => (el.id === dest.parent_id) && (el.level === countryLevel + 1))
        if (!city) return null
        return city.id
      },
      set (val) {
        this.selectedParams.to = val
      }
    },
    cityDisabled () {
      return !this.destinationCountry
    },
    areaOptions () {
      if (!this.city) return []
      return model.destinations
        .filter(el => el.level === countryLevel + 2)
        .filter(el => (el.parent_id === this.city))
        .map(el => {
          let text = ''
          for (let i = 0; i < el.level; i++) text += '  '
          text += el.name
          return { value: el.id, text: text }
        })
    },
    area: {
      get () {
        if (!this.city) return null
        const dest = model.destinations.find(el => (el.id === this.selectedParams.to))
        if (!dest) return null
        if (dest.level === countryLevel + 2) return dest.id
        return null
      },
      set (val) {
        this.selectedParams.to = val
      }
    },
    areaDisabled () {
      return !this.city
    },
    countryOptions () {
      return model.destinations
        .filter(el => el.level === countryLevel)
        .map(el => ({
          value: el.id,
          text: el.name
        }))
    },
    destinationCountry: {
      get () {
        if (this.country) return this.country
        if (this.selectedParams.to === null) return this.country
        let country = model.destinations.find(el => el.id === this.selectedParams.to)
        while (country && country.level > countryLevel) {
          country = model.destinations.find(el => el.id === country.parent_id)
        }
        if (!country) return this.country
        return country.id
      },
      set (val) {
        this.country = val
        if (this.selectedParams.to) {
          const dest = model.destinations.find(el => el.parent_id === val)
          if (dest && dest.parent_id !== val) this.selectedParams.to = null
        }
      }
    },
    departureDatesOptions () {
      return model.departureDates
        .map(
          el => {
            const d = moment(el.date, 'YYYY-MM-DD').format('DD-MM-YYYY')
            return {
              value: d,
              text: d,
              disabled: (el.available <= 0)
            }
          }
        )
    },
    returnDatesOptions () {
      let sDate = ''
      if (this.selectedParams.date_from) {
        sDate = moment(this.selectedParams.date_from, 'DD-MM-YYYY').format('YYYY-MM-DD')
      }
      return model.returnDates
        .filter(el => sDate < el.date)
        .map(
          el => {
            const d = moment(el.date, 'YYYY-MM-DD').format('DD-MM-YYYY')
            return {
              value: d,
              text: d,
              disabled: el.available <= 0
            }
          }
        )
    },
    departureDateDisabled () {
      return !(this.city && this.selectedParams.from)
    },
    returnDateDisabled () {
      return !(this.city && this.selectedParams.from)
    },
    selectedCheckIn: {
      get () {
        if (!this.departureDatesOptions.length) return null
        return this.selectedParams.date_from
      },
      set (val) {
        this.selectedParams.date_from = val
      }
    },
    selectedCheckOut: {
      get () {
        if (!this.returnDatesOptions.length) return null
        return this.selectedParams.date_to
      },
      set (val) {
        this.selectedParams.date_to = val
      }
    }
  },
  methods: {
    submit () {
      this.$refs.searchForm.validate().then(success => {
        if (!success) {
          this.addToast({ title: 'Formular invalid', message: 'Va rugam completati toate campurile obligatorii!', variant: 'danger' })
        } else {
          this.selectedParams.adults = this.room.adults
          this.selectedParams.ages = this.room.child_ages
          this.onSubmit()
        }
      })
    },
    async onDestinationChange (val) {
      model.departures = await getDeparturePoints({
        destination: this.city,
        dc: model.distribution
      })
      if (this.selectedParams.from && this.city) await this.updateDates()
    },
    async onDepartureChange (val) {
      if (this.selectedParams.from && this.city) await this.updateDates()
    },
    async updateDates () {
      const promises = []
      promises.push(getDates({
        type: 'in',
        to: this.selectedParams.from,
        from: this.city,
        dc: model.distribution
      }))
      if (this.selectedParams.route_type === 'return' || this.selectedParams.route_type === 'out') {
        promises.push(getDates({
          type: 'out',
          from: this.selectedParams.from,
          to: this.city,
          dc: model.distribution
        }))
      }
      const results = await Promise.all(promises)
      if (results.length > 1) model.departureDates = results[1]
      model.returnDates = results[0]

      const noNights = this.noNights || this.defaultNights

      if (this.selectedParams.date_from) {
        let myDate = moment(this.selectedParams.date_from, 'DD-MM-YYYY')
        let sDate = myDate.format('YYYY-MM-DD')

        let d = model.departureDates.find(
          el => (el.available > 0) && (el.date >= sDate)
        )
        if (!d) d = model.departureDates.find(el => el.available > 0)
        if (d) this.selectedParams.date_from = moment(d.date, 'YYYY-MM-DD').format('DD-MM-YYYY')
        else this.selectedParams.date_from = null

        myDate = moment(this.selectedParams.date_from, 'DD-MM-YYYY')

        if (noNights) myDate.add(noNights, 'days')
        else myDate.add(1, 'days')

        sDate = myDate.format('YYYY-MM-DD')

        d = model.returnDates.find(
          el => (el.available > 0) && (el.date >= sDate)
        )
        if (!d) d = model.returnDates.find(el => el.available > 0)
        if (d) this.selectedParams.date_to = moment(d.date, 'YYYY-MM-DD').format('DD-MM-YYYY')
        else this.selectedParams.date_to = null
      }
    },
    onCheckOutChange (val) {
      const mVal = moment(val, 'DD-MM-YYYY')
      // check to see if it is a valid value
      // it it's invalid don't do anything
      if (!mVal.isValid()) return
      let mCheckIn = moment(this.selectedCheckIn, 'DD-MM-YYYY')
      if (!mCheckIn.isValid() || mCheckIn.isAfter(mVal)) {
        // modify check in according to no of nights
        if (!mCheckIn.isValid()) mCheckIn = moment(mVal).hour(15).minute(0).second(0)
        this.selectedParams.date_to = mCheckIn.subtract(this.nights, 'days').format('DD-MM-YYYY')
      }
      this.calculateNights()
    },
    onCheckInChange (val) {
      const mVal = moment(val, 'DD-MM-YYYY')
      // check to see if it is a valid value
      // it it's invalid don't do anything
      if (!mVal.isValid()) return
      const mCheckOut = moment(mVal).hour(11).minute(0).second(0)
      this.selectedParams.date_to = mCheckOut.add(this.nights, 'days').format('DD-MM-YYYY')
      this.calculateNights()
    },
    calculateNights () {
      if (this.selectedCheckIn && this.selectedCheckOut) {
        this.nights = moment(this.selectedCheckOut, 'DD-MM-YYYY').startOf('day')
          .diff(
            moment(this.selectedCheckIn, 'DD-MM-YYYY').startOf('day'),
            'days'
          )
      } else this.nights = this.defaultNights
    }
  },
  created () {
    this.selectedParams = { ...this.params }
    this.room = {
      adults: this.selectedParams.adults,
      ages: this.selectedParams.child_ages
    }
    this.calculateNights()
  }
}
</script>
